



















































































































/** @format */

import { Vue, Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { IAntColumn } from '@root/types/table';
import { getInvoiceRecordList, downloadInvoiceLift } from '@/api/financial-management/index';
import moment from 'moment';
import Utils from '@root/utils/common';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import PlateInput from '@/components/plate-input/index.vue';
@Component({
  name: 'InvoiceRecord',
  components: {
    ParkingLotSearch,
    PlateInput
  }
})
// @ts-ignore
export default class InvoiceRecord extends Mixins(TableMixin, TableWidthMixin) {
  private pageSize = 10;
  private totalNum = 0;
  private totalPage = 1;
  private current = 1;
  private tableData: any = [];
  private sumRowData = {}; // 合计数据
  private detail: any = {};
  private tableLoading: boolean = false;
  plateInputModel: boolean = false;
  private filterParam = {
    parkIds: [],
    plateHead: '',
    plateTail: '',
    invoiceEndDate: '',
    invoiceStartDate: '',
    invoiceNo: '',
    sellerName: '',
    plate: '',
    tradeNo: '',
    statusList: [],
    productTypeList: []
  };
  private moment = moment;
  invoiceStatusOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.invoice_status || {});
  productTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.invoice_type || {});
  created() {
    this.fetchTableData();
  }
  onSearch() {
    this.current = 1;
    this.fetchTableData();
  }

  /**
   * 获取数据
   */
  async fetchTableData(isRefresh?: boolean) {
    const {
      parkIds,
      plateHead,
      plateTail,
      invoiceEndDate,
      invoiceStartDate,
      invoiceNo,
      sellerName,
      tradeNo,
      statusList,
      productTypeList
    } = this.filterParam;
    if (plateTail && plateHead === '') {
      return this.$message.error('请先选择省份再进行查询');
    }
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { status, msg, data = {} } = await getInvoiceRecordList({
        parkIds: '' + parkIds,
        plateHead,
        plateTail,
        invoiceEndDate,
        invoiceStartDate,
        invoiceNo,
        sellerName,
        tradeNo,
        statusList: statusList,
        productTypeList,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas = [], total, totalNum, totalPage, pageSize } = data;
      const { totalPrice } = total;
      this.tableData = datas;
      this.sumRowData = { totalPrice };
      this.total = totalNum - 0;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }
  /**
   * 设置可选择时间
   * @param current
   */
  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }
  set defaultTime(val: any) {}
  get defaultTime() {
    if (this.filterParam.invoiceStartDate && this.filterParam.invoiceEndDate) {
      return [
        this.moment(this.filterParam.invoiceStartDate, 'YYYY-MM-DD'),
        this.moment(this.filterParam.invoiceEndDate, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.invoiceStartDate) {
      return [this.moment(this.filterParam.invoiceStartDate, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  /**
   * @param {点击导出按钮}
   */
  async download() {
    try {
      const {
        parkIds,
        plateHead,
        plateTail,
        invoiceEndDate,
        invoiceStartDate,
        invoiceNo,
        sellerName,
        tradeNo,
        statusList,
        productTypeList
      } = this.filterParam;
      //downloadOrderHandLiftDownload
      await downloadInvoiceLift(
        {
          parkIds: '' + parkIds,
          plateHead,
          plateTail,
          invoiceEndDate,
          invoiceStartDate,
          invoiceNo,
          sellerName,
          tradeNo,
          statusList: statusList,
          productTypeList
        },
        '电子发票'
      );
    } catch (e) {
      console.log('exportOrderEnter', '导出失败');
    }
  }
  /**
   * @param {点击清除按钮}
   */
  onClear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList,
      plateHead: '',
      plateTail: '',
      invoiceEndDate: '',
      invoiceStartDate: '',
      invoiceNo: '',
      sellerName: '',
      plate: '',
      tradeNo: '',
      statusList: [],
      productTypeList: []
    };
    this.onSearch();
  }
  /**
   * 时间变化
   * @param date
   * @param dateString
   */
  onTimeChange(date: any, dateString: string[]) {
    let [invoiceStartDate, invoiceEndDate] = dateString;
    this.filterParam.invoiceEndDate = invoiceEndDate;
    this.filterParam.invoiceStartDate = invoiceStartDate;
  }
  toDetail(detail: any) {
    const { pdfurl, status } = detail;
    if (status == '01' || status == '02') return window.open(pdfurl);
  }
  get tableColums(): IAntColumn[] {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        width: 200,
        dataIndex: 'parkName',
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        width: 170,
        dataIndex: 'plate',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '交易流水号',
        width: 330,
        dataIndex: 'tradeNo',
        scopedSlots: { customRender: 'text-ellipse-more' }
      },
      {
        title: '开票流水号',
        width: 330,
        dataIndex: 'orderId',
        customRender: (text: any) => text || '--'
      },
      {
        title: '购方名称',
        width: 170,
        dataIndex: 'payerName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '销方名称',
        width: 170,
        dataIndex: 'sellerName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '发票号码',
        width: 170,
        dataIndex: 'invoiceNo',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '发票代码',
        width: 170,
        dataIndex: 'invoiceCode',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '开票金额',
        dataIndex: 'totalPrice',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '开票项目',
        width: 180,
        dataIndex: 'productType',
        customRender: (text: any) => text || '--'
      },
      {
        title: '开票日期',
        width: 180,
        dataIndex: 'invoiceDate',
        customRender: (text: any) => text || '--'
      },
      {
        title: '开票状态',
        width: 180,
        dataIndex: 'statusName',
        customRender: (text: any) => text || '--'
      },
      {
        title: '邮箱',
        width: 180,
        dataIndex: 'email',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '手机号',
        width: 140,
        dataIndex: 'mobile',
        customRender: (text: any) => text || '--'
      },
      {
        title: '备注',
        width: 180,
        dataIndex: 'msg',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 100
      }
    ];
  }
}
